export default __webpack_public_path__ + "static/Gmail-page-footer-img-45262a4c0de465cf84b4373c5c145bf2.png";